import { popupErrorMessage } from './messages';

export const redirectNewPage = (link: string) => {
    if (!link) {
        return;
    }
    const newWin = window.open(link);

    if (!newWin || newWin.closed || typeof newWin.closed == 'undefined') {
        popupErrorMessage(link);
    }
};
